import React, { useEffect, useMemo, useState } from "react";

import "react-horizontal-strip-datepicker/dist/ReactHorizontalDatePicker.css";
import CalendarLayout from "../../Layout/CalendarLayout/CalendarLayout";
import {
  activeChildDetail,
  appConstants,
  NotificationAtom,
} from "../../AtomStore/store";
import { useAtom } from "jotai";
import { useRequestProcessor } from "../../requestProcessor";
import { fetchChildTimeline } from "../../QueryFunctions/queryfunction";

import NotificaionItem from "./Item";

import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";

import moment from "moment";
import { SERVER_DATE_FORMAT } from "../../Pages/Support/TakeABreak/TakeABreak";

const Notification = () => {
  const [childTimeline] = useState({ startIndex: 0 });
  const [activeChild] = useAtom(activeChildDetail);
  const ITEM_PER_PAGE = 50;
  const [, setDataAvailable] = useState(true);
  const { useQueryWrapper } = useRequestProcessor();
  const [, setLength] = useState(0);
  const [ChildTimeline, setTimeline] = useAtom(NotificationAtom);

  const [constants] = useAtom(appConstants);
  const [selectedDate, setSelectedDate] = useState(
    moment().format(SERVER_DATE_FORMAT)
  );
  const [, setError] = useState(null);

  useMemo(() => {
    console.log(
      `[Child Timeline] Fetching Child Timeline for user: ${activeChild?.id}`
    );
  }, [activeChild]);
  // [My Center] Calling API: /mycenter/all {page: 4, }
  // [My Center] Received center: 9: {[Conference_1], []}
  const { isLoading, isFetching } = useQueryWrapper(
    [
      "ChildTimeline",
      "timeline" + activeChild?.id,
      childTimeline,
      selectedDate,
    ],
    () =>
      fetchChildTimeline(
        childTimeline.startIndex,
        setDataAvailable,
        ChildTimeline,
        ITEM_PER_PAGE,
        constants?.INCLUDE_TYPES_NOTIFICATION,
        setLength,
        setTimeline,
        selectedDate
      ),
    {
      onSuccess: (data) => {
        if (data?.status) {
        } else {
          setTimeline(data);
          setError(null);
        }
      },
      onError: (err) => {
        setError("Failed to fetch the food menu. Please try again later.");
      },
    }
  );

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // const next = () => {
  //   const startIndex = childTimeline.startIndex + ITEM_PER_PAGE;

  //   setChildTimeline({ startIndex: startIndex });
  // };

  // const handleRefresh = () => {
  //   setDataAvailable(true);
  //   setLength(0);
  //   refetch();
  // };

  const handleSelectedDate = (val) => {
    // console.log('setSelectedDate: ', val);
    setSelectedDate(val);
  };
  return (
    <>
      <div className="bg-[#eaf3fa] h-full">
        <div className="bg-header h-[40vh] xs:h-[30vh] p-2"></div>
        <div className="bg-white mx-3 px-3 py-4 rounded-2xl relative top-[-180px] xsm:top-[-140px] [@media(max-height:580px)]:-top-16">
          {/* {isFetching ? <SpinnerLoading /> : <></>} */}
          <div className="text-center">
            <h3 className="text-lg font-bold">Notifications</h3>
            {/* <h3 className="text-md font-extrabold"> 03/03</h3> */}
          </div>
          <div className=" bg-header  h-1 mt-2 mx-5 rounded-full"></div>

          {/* <div class="w-full bg-[#e5e7eb] rounded-full h-2 dark:bg-gray-700 mt-3">
        <div class="bg-green h-2 rounded-full" style={{ width: '45%' }}></div>
      </div> */}

          {(isLoading || isFetching) && (
            <div className=" m-3">
              {[1, 2, 3].map((ele) => (
                <div
                  className="animate-pulse flex items-center space-x-4 mt-4 border-b pb-3"
                  key={ele}
                >
                  <div className="rounded-full bg-slate-200 h-10 w-10"></div>
                  <div className="flex-1 space-y-6 py-1">
                    <div className="space-y-3">
                      <div className="grid grid-cols-3 gap-4">
                        <div className="h-2 bg-slate-200 rounded col-span-2"></div>
                      </div>
                      <div className="h-2 bg-slate-200 rounded"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {Array.isArray(ChildTimeline) &&
            ChildTimeline.length > 0 &&
            !(isLoading || isFetching) && (
              <ul className="list-none mt-4">
                {ChildTimeline?.map((items, index) => (
                  <>
                    {" "}
                    <div className="text-center bg-header/20   sm:mx-20 md:mx-20 lg:mx-50 xl:mx-80 rounded-full py-1 mb-2">
                      <h3 className="text-lg font-bold text-header">
                        {moment(items.dateGroup, "DD-MM-YY").format(
                          "MMMM D, YYYY"
                        )}
                      </h3>
                      {/* <h3 className="text-md font-extrabold"> 03/03</h3> */}
                    </div>
                    <NotificaionItem
                      history={""}
                      items={items}
                      key={index}
                      index={index}
                    />
                  </>
                ))}
              </ul>
            )}
          {(!Array.isArray(ChildTimeline) ||
            ChildTimeline.length === 0 ||
            ChildTimeline === undefined) && (
            <div className="text-center mt-4 h-[30vh]">
              <ListEmptyComponent
                heading={isLoading || isFetching ? <></> : "No Data Found"}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Notification;
